import {useEffect, useState} from "react";

/** A media query casa agora? Atualiza quando a janela muda de tamanho. */
const useMidia = (consulta: string): boolean => {
    const [casa, setCasa] = useState(() => window.matchMedia(consulta).matches);
    useEffect(() => {
        const lista = window.matchMedia(consulta);
        const muda = () => setCasa(lista.matches);
        lista.addListener(muda);
        muda();
        return () => lista.removeListener(muda);
    }, [consulta]);
    return casa;
};

export const DESKTOP = '(min-width: 992px)';
export const CELULAR = '(max-width: 767px)';

export default useMidia;
